import React from "react";
import { useIntl } from "react-intl";
import { LoaderContainer, LoaderImg } from "./styles";
import loadingSvg from "../../../assets/gif/flowio-loader.svg";

const NATIVE_GIF_SIZE = 231;

const Loader = ({ size = NATIVE_GIF_SIZE, className }: LoaderProps) => {
  const { formatMessage } = useIntl();
  const alt = formatMessage({ id: "common.loading" });

  return (
    <LoaderContainer className={className}>
      <LoaderImg
        alt={alt}
        size={size}
        src={loadingSvg}
        data-cy="loader-image"
      />
    </LoaderContainer>
  );
};

type LoaderProps = {
  className?: string;
  size?: number;
};

export default Loader;
